var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-container"},[(!_vm.hockMaterialList || _vm.hockMaterialList.length === 0)?_c('el-empty',{attrs:{"description":"暂无数据"}}):_c('div',{staticClass:"order-info"},[_c('order-material',{attrs:{"materials":_vm.hockMaterialList,"model":3}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }